import React, { Component } from 'react';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';

import { withStyles } from '@material-ui/core/styles';

import { formFields } from './fieldTypes';

const styles = theme => ({
  root: {
    borderLeft: `1px solid ${theme.palette.grey['100']}`
  },

  tabContent: {
    padding: theme.spacing(4)
  },

  fieldListWrapper: {
    position: 'relative',
    width: '100%',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    '& li': {
      color: theme.palette.grey['800'],
      padding: theme.spacing(),
      cursor: 'pointer',
      fontSize: '14px',
      border: `1px dashed ${theme.palette.grey['400']}`,
      margin: '0 0 5px',
      transition: 'background-color 0.25s ease-in-out',
      position: 'relative',
      '& span': {
        transition: 'opacity 0.25s ease-in-out',
        position: 'absolute',
        right: theme.spacing(),
        top: theme.spacing(),
        opacity: 0
      },
      '&:hover': {
        borderColor: theme.palette.primary.main,
        background: theme.palette.primary.main,
        color: '#fff',
        '& span': {
          opacity: 1
        }
      },
      '& svg': {
        verticalAlign: 'middle',
        fontSize: '20px',
        margin: '-2px 5px 0 0'
      }
    }
  }
});

class FieldsAndFieldGroups extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  renderFields = (arrayIndex = 0) => {
    return formFields[arrayIndex].map(field => {
      return (
        <li
          key={`droppable_form_field_${field.type}`}
          onClick={() => this.props.onAdd({ field: `${field.type}, field` })}
          type="field"
          data={`${field.type}, field`}
        >
          {field.icon()} {field.name}
          <span>click to add</span>
        </li>
      );
    });
  };

  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <Tabs
          value={this.state.value}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          fullWidth
        >
          <Tab label="Fields" />
          <Tab label="Field Groups" />
        </Tabs>
        <SwipeableViews
          axis="x"
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
        >
          <div className={classes.tabContent}>
            <Grid container spacing={24}>
              <Grid item xs={12} md={6}>
                <ul className={classes.fieldListWrapper}>
                  {this.renderFields()}
                </ul>
              </Grid>
              <Grid item xs={12} md={6}>
                <ul className={classes.fieldListWrapper}>
                  {this.renderFields(1)}
                </ul>
              </Grid>
            </Grid>
          </div>
          <div>Field Groups</div>
        </SwipeableViews>
      </div>
    );
  }
}

export default connect(
  state => ({}),
  {}
)(withStyles(styles)(FieldsAndFieldGroups));
